import { Component } from '@angular/core';

@Component({
  selector: 'app-no-project-access',
  templateUrl: './no-project-access.component.html',
  styleUrls: ['./no-project-access.component.scss'],
  standalone: false,
})
export class NoProjectAccessComponent {}
